module.exports = __webpack_public_path__ + "img/Edit.c5a431a9.png";